"use client";
import { Dropdown, Paragraph } from "@digdir/designsystemet-react";
import {
  CheckmarkIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from "@navikt/aksel-icons";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { availableLanguages } from "@/config/i18n";
import { env } from "@/env";
import { languageConfig, usePersistantState } from "@/features/bestillinger";
import { cn } from "@/utils";

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [_, setLanguage] = usePersistantState(
    languageConfig.storageKey,
    i18n.language,
    languageConfig.storageType,
  );

  const debugLang = "debug";
  return (
    <Dropdown.TriggerContext data-color="neutral">
      <Dropdown.Trigger
        variant="tertiary"
        className="flex items-center gap-2"
        onClick={() => setOpen((prev) => !prev)}
      >
        <Paragraph>{t("app.language")}</Paragraph>
        {open ? <ChevronUpIcon aria-hidden /> : <ChevronDownIcon aria-hidden />}
      </Dropdown.Trigger>
      <Dropdown
        open={open}
        placement="bottom-end"
        onClose={() => setOpen(false)}
      >
        <Dropdown.List>
          {availableLanguages.map((lang) => {
            const isActiveLang = lang === i18n.language;
            return (
              <Dropdown.Item key={lang}>
                <Dropdown.Button
                  onClick={() => {
                    setOpen(false);
                    setLanguage(lang);
                    i18n.changeLanguage(lang);
                  }}
                  className={cn(isActiveLang ? "bg-balder-surface-hover" : "")}
                >
                  {isActiveLang && <CheckmarkIcon fontSize="1.5rem" />}
                  <span>{t("app.language", { context: lang })}</span>
                </Dropdown.Button>
              </Dropdown.Item>
            );
          })}
          {env.isDebug && (
            <Dropdown.Item key={debugLang}>
              <Dropdown.Button
                onClick={() => {
                  setOpen(false);
                  setLanguage(debugLang);
                  i18n.changeLanguage(debugLang); // Example for a development language
                }}
              >
                <span>Debug</span>
              </Dropdown.Button>
            </Dropdown.Item>
          )}
        </Dropdown.List>
      </Dropdown>
    </Dropdown.TriggerContext>
  );
}
